module.exports = __webpack_public_path__ + "static/media/A_iko_2_kontrast.db584ec5.svg";